var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbnailPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 169
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "thumbnail-placeholder_svg__a",
    d: "M0 0h300v168.649H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "thumbnail-placeholder_svg__c",
    d: "M697.99 113.254l.05.277c11.004 62.545-30.754 122.183-93.291 133.233l-188.527 33.258c-62.544 11.051-122.193-30.709-133.227-93.256-.001-.006-.002-.011.015-.02l-.05-.277c-11.004-62.545 30.754-122.183 93.291-133.233l188.527-33.258c62.544-11.051 122.193 30.709 133.227 93.256.001.006.002.011-.015.02z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "thumbnail-placeholder_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#thumbnail-placeholder_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F2E5",
    xlinkHref: "#thumbnail-placeholder_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#thumbnail-placeholder_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-167 -216)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#A3A6E5",
    xlinkHref: "#thumbnail-placeholder_svg__c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181,
    cy: 478.5,
    fill: "#FFE6CC",
    rx: 181,
    ry: 178.5
  }))))));
}

export default SvgThumbnailPlaceholder;